import { Component, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import { NullableString } from '../../../biz/data/Types';
import { Config } from '../../../biz/data/Config';

const portalRoot = document.getElementById("portal") as HTMLElement;
const alertRoot = document.getElementById("alert") as HTMLElement;

// Portals
export const Portal = ({ visible, children }: { visible: boolean, children: ReactNode }) => {
    if (visible !== true) {
        return null;
    }
    return (
        <>
            {ReactDOM.createPortal(
                <>
                    {children}
                </>
                , portalRoot)}
        </>
    )
}
const AlertPortal = ({ visible, children }: { visible: boolean, children: ReactNode }) => {
    if (visible !== true) {
        return null;
    }
    return (
        <>
            {ReactDOM.createPortal(
                <>
                    {children}
                </>
                , alertRoot)}
        </>
    )
}

// PortalContainers
export const PortalContainer = ({ visible, children, clickOutside, containerClass }: { visible: boolean, children?: ReactNode, clickOutside?(): void, containerClass?: string }) => {
    return (
        <Portal visible={visible}>
            <div id="overlay" />
            <div id="overlay-container" onClick={e => {
                if ((e.target as any)?.["id"] === "overlay-container") {
                    if (!!clickOutside) {
                        clickOutside()
                    }
                }
            }}>
                <div className={containerClass}>
                    {children}
                </div>
            </div>
        </Portal>
    )
}

export const AlertContainer = ({ visible, children, clickOutside }: { visible: boolean, children: ReactNode, clickOutside?(): void }) => {
    return (
        <AlertPortal visible={visible}>
            <div id="overlay" />
            <div id="overlay-container" onClick={e => {
                if ((e.target as any)?.["id"] === "overlay-container") {
                    if (!!clickOutside) {
                        clickOutside()
                    }
                }
            }}>
                <div>
                    {children}
                </div>
            </div>
        </AlertPortal>
    )
}

export const PlantIframeDialog = ({ plantId, close }: { plantId: NullableString, close(): void }) => {

    return (
        <PortalContainer visible={!!plantId} clickOutside={close}>
            <iframe className="iframe"
                src={Config.appData_GetPOlabtLink(plantId)}
                style={{
                    background: "white",
                    width: "40dvw",
                    height: "80dvh",
                    borderRadius: "32px",
                    border: "0"
                }}
                onLoad={e => {
                    const doc = document.getElementsByTagName("iframe");
                    console.log("doc:", doc);
                }}
            ></iframe>

        </PortalContainer>
    )
}